import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
  .set('GetAll', new Immutable.List([]))
  .set('GetConsultant', new Immutable.Map({}))


/* Types */
export const ACTION_SEARCH_INTEGRALVALUATION = 'ACTION_SEARCH_INTEGRALVALUATION'
export const ACTION_GET_INTEGRALVALUATION_CONSULTANT = 'ACTION_GET_INTEGRALVALUATION_CONSULTANT'

/* Reducer */
export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_SEARCH_INTEGRALVALUATION:
      return state.set('GetAll', new Immutable.List(action.Obj))
    case ACTION_GET_INTEGRALVALUATION_CONSULTANT:
      return state.set('GetConsultant', new Immutable.Map(action.Obj))
    default:
      return state
  }
}

/* Action Creators */

export const addIntegralValuation = (form) => {

  let data = Object.assign({}, form)

  let tmp = {
    id: data.id,
    descripcion: data.descriptionIntegral,
    estatus: data.status === 1 ? false : true,
    autor: sessionStorage.uid,
    rangos: Utils.unionArray(data.rangeNew, data.rangeNewRemove),
    ponderaciones: Utils.unionArray(data.evaluationNew, data.evaluationNewRemove)
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: data.id ? 'api/updateIntegralValuation' : 'api/addIntegralValuation',
      method: 'POST',
      data: { ...tmp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then((response) => {
      dispatch(isLoading(false))
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const searchIntegralValuation = (form) => {

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: Object.keys(form).length ? 'api/searchIntegralValuationByParams' : 'api/searchIntegralValuation',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))

      response.data = response.data.map((r) => {
        r.deleted = r.estatus ? r.estatus : r.deleted
        return r
      })

      dispatch({ type: ACTION_SEARCH_INTEGRALVALUATION, Obj: response.data })
      return response
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const getIntegralValuationConsultant = (idConfiguracionValoracionIntegral) => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getIntegralValuationConsultant',
      method: 'POST',
      data: { idConfiguracionValoracionIntegral },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_GET_INTEGRALVALUATION_CONSULTANT, Obj: response.data })
      return response
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const updateIntegralValuation = (form) => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updateIntegralValuation',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      return response
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const clearIntegralValuation = () => {
  return dispatch => {
    dispatch({ type: ACTION_SEARCH_INTEGRALVALUATION, Obj: [] })
    return Promise.resolve()
  }
}



// WEBPACK FOOTER //
// ./src/modules/Catalogs/IntegralValuation/IntegralValuation.js